import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MagnifyingGlass, Book } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

const GaytionaryPage = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const terms = [
    { term: 'Ass Play', definition: 'Anal insertion of fingers, fist, dildos, or other objects.' },
    { term: 'Barebacking / BB', definition: 'Anal sex without a condom.' },
    { term: 'BDSM', definition: 'Bondage and Discipline, Dominance and Submission, Sadism and Masochism. Role play involving physical restraints and focusing on intense stimulation and/or playing with power relations.' },
    { term: 'Booty Bumping', definition: 'Administering a water-soluble drug by injecting it into the rectum with a needleless syringe. Also called boofing or plugging.' },
    { term: 'Bottom', definition: 'Passive sexual role.' },
    { term: 'Chems', definition: 'Drugs, chemical substances.' },
    { term: 'Chemsex', definition: 'The consumption of drugs or chemical substances to facilitate or enhance sexual activity.' },
    { term: 'Coming Out', definition: 'Self-disclosure of sexual orientation to the outside world.' },
    { term: 'Coming Down', definition: 'Immediate aftermath of drug use, during which the physical and psychological consequences of use are experienced.' },
    { term: 'Crystal Meth', definition: 'Name for methamphetamine, a potent central nervous system stimulant that is mainly used as a recreational drug for its euphoriant and aphrodisiac qualities.' },
    { term: 'Fisting / FF', definition: 'Sexual activity that involves inserting a hand (fist), and optionally a part of the arm, into the rectum or vagina. Also called handballing or brachiovaginal/brachioproctic insertion.' },
    { term: 'GBL', definition: 'A chemical solvent found in nail polish remover and wheel cleaner, used for making GHB. It has no effect until the body converts it into GHB, which it does rapidly.' },
    { term: 'GHB / G / Gina', definition: 'A naturally occurring neurotransmitter and a psychoactive drug. A central nervous system depressant used as an intoxicant with effects comparable to ethanol and MDMA.' },
    { term: 'HnH', definition: 'Usually means "High and Horny."' },
    { term: 'Mephedrone', definition: 'A synthetic stimulant drug of the amphetamine and cathinone classes. Slang names include bath salts, drone, M-CAT, white magic, and meow meow. Comes in tablets or powder form.' },
    { term: 'MSM', definition: 'Men who have sex with men.' },
    { term: 'Party and Play / PnP', definition: 'The consumption of drugs to facilitate or enhance sexual activity.' },
    { term: 'PEP', definition: 'Post-Exposure Prophylaxis - emergency HIV medication taken within 72 hours of potential exposure.' },
    { term: 'Pig', definition: 'Aficionado of more extreme forms of sex.' },
    { term: 'Poppers', definition: 'A slang term for alkyl nitrites that are inhaled. Used to facilitate anal sex by increasing blood flow and relaxing sphincter muscles, or for the "rush" feeling.' },
    { term: 'PrEP', definition: 'Pre-Exposure Prophylaxis - daily medication that protects HIV-negative people from getting HIV.' },
    { term: 'Rush', definition: 'Sudden and immediate surge of physical feeling experienced after taking certain drugs.' },
    { term: 'Slamming', definition: 'Administering substances intravenously.' },
    { term: 'Sleazy', definition: 'Uninhibited, relatively extreme sex, usually involving the exchange of bodily fluids.' },
    { term: 'TasP', definition: 'Treatment as Prevention - HIV treatment prevents HIV transmission.' },
    { term: 'Tina / T', definition: 'Slang for crystal meth.' },
    { term: 'Top', definition: 'Active sexual role.' },
    { term: 'U=U', definition: 'Undetectable = Untransmittable. When HIV viral load is undetectable, it cannot be passed on sexually.' },
    { term: 'Undetectable', definition: 'When HIV treatment reduces viral load to levels that cannot be detected by standard tests.' },
    { term: 'Upper', definition: 'A drug that has a stimulating effect on the central nervous system.' },
    { term: 'Versatile', definition: 'Alternating sexual role (both top and bottom).' },
    { term: 'Viral Load', definition: 'Amount of HIV (virus) per cubic milliliter of blood.' }
  ];

  const filteredTerms = terms.filter(item =>
    item.term.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.definition.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen flex flex-col relative z-10">
      <header className="glass-morphism sticky top-0 z-50 border-b">
        <div className="max-w-2xl mx-auto px-6 py-4">
          <div className="flex items-center">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate('/')}
              data-testid="back-button"
              className="mr-4 text-[rgb(var(--text-secondary))] hover:text-[rgb(var(--primary))]"
            >
              <ArrowLeft size={24} weight="duotone" />
            </Button>
            <div className="flex items-center space-x-2">
              <span className="text-3xl emoji-bounce">🏳️‍🌈</span>
              <h1 className="text-2xl font-bold text-gradient">
                GAY-tionary
              </h1>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-2xl mx-auto w-full px-6 py-8 pb-24">
        {/* Hero */}
        <div className="mb-6 p-6 party-gradient rounded-3xl text-white text-center">
          <div className="text-4xl mb-2">📖</div>
          <h2 className="text-xl font-bold mb-2">Know the Language</h2>
          <p className="text-white/90 text-sm">
            A glossary of terms used in PnP, chemsex, and queer communities. Knowledge is power. 💜
          </p>
        </div>

        {/* Search */}
        <div className="relative mb-6">
          <MagnifyingGlass 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-[rgb(var(--text-secondary))]" 
          />
          <input
            type="text"
            placeholder="Search terms..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            data-testid="search-input"
            className="w-full pl-12 pr-4 py-3 bg-[rgb(var(--surface))] border border-white/10 rounded-xl text-[rgb(var(--text-primary))] placeholder:text-[rgb(var(--text-secondary))] focus:outline-none focus:border-[rgb(var(--primary))]/50"
          />
        </div>

        {/* Terms count */}
        <p className="text-sm text-[rgb(var(--text-secondary))] mb-4">
          {filteredTerms.length} terms {searchTerm && `matching "${searchTerm}"`}
        </p>

        {/* Terms List */}
        <div className="space-y-3">
          {filteredTerms.map((item, index) => (
            <div
              key={index}
              data-testid={`term-${index}`}
              className="bg-[rgb(var(--surface))] rounded-2xl p-5 border border-white/5 hover:border-[rgb(var(--primary))]/20 transition-all"
            >
              <div className="flex items-start">
                <Book size={18} weight="duotone" className="text-[rgb(var(--primary))] mr-3 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-bold text-[rgb(var(--text-primary))] mb-1">
                    {item.term}
                  </h3>
                  <p className="text-sm text-[rgb(var(--text-secondary))] leading-relaxed">
                    {item.definition}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredTerms.length === 0 && (
          <div className="text-center py-12">
            <div className="text-4xl mb-4">🔍</div>
            <p className="text-[rgb(var(--text-secondary))]">No terms found for "{searchTerm}"</p>
          </div>
        )}

        {/* Footer note */}
        <div className="mt-8 p-4 bg-[rgb(var(--primary))]/10 border border-[rgb(var(--primary))]/20 rounded-2xl text-center">
          <p className="text-sm text-[rgb(var(--text-secondary))]">
            Language evolves. These definitions reflect common usage in 2SLGBTQ+ and harm reduction communities.
          </p>
        </div>
      </main>
    </div>
  );
};

export default GaytionaryPage;
